import React, { forwardRef, useContext } from 'react';
const OverrideContainerContext = /*#__PURE__*/React.createContext({});
export function OverrideContainer({
  soft,
  hard,
  children
}) {
  return /*#__PURE__*/React.createElement(OverrideContainerContext.Provider, {
    value: {
      soft,
      hard
    }
  }, children);
}
function useContainerOverride(props) {
  const {
    soft,
    hard
  } = useContext(OverrideContainerContext);
  return {
    ...soft,
    ...props,
    ...hard
  };
}
export function overrideProps(Component) {
  return /*#__PURE__*/forwardRef((props, ref) => {
    const overridedProps = useContainerOverride(props);
    return /*#__PURE__*/React.createElement(Component, {
      ...overridedProps,
      ref: ref
    });
  });
}